const Constants = Object.freeze({
  // -----------------------------------------------------------------------------
  // -------------------------------- PROTOCOLO ----------------------------------
  // -----------------------------------------------------------------------------

  // ---------------------------- HOME ----------------------------
  TIME_ON: "Tempo ligado: ",
  NUM_OF_DEVICES: "Número de dispositivos",
  MASTERS: "Mestres",
  SLAVES: "Escravos",
  STATISTICS: "Estatísticas",

  NO_RETRIES: "Sem retentativas",

  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  CYCLE_TIME_S: "TEMPO DE CICLO (s)",
  CYCLE_TIME_MS: "TEMPO DE CICLO (ms)",

  WATCHDOG_MS: "WATCHDOG (ms)",

  RETRIES_LIMIT: "LIMITE DE RETENTATIVA",

  PROFIBUS_NETWORK_INFO: "Informações da rede PROFIBUS",

  HSA_POPUP_1: "HSA (Highest PROFIBUS Address) é o parâmetro que indica o maior endereço que o mestre realiza a busca por novos equipamentos na rede, utilizando o protocolo FDL_Status.",
  HSA_POPUP_2: "Utilizado também para detecção de mestres classe 2 ou redes com mais de um mestre.",

  // ---------------------------- Live List ----------------------------
  AVAILABILITY: "Disponibilidade",
  TAG: "Tag",
  ACTIVE: "Ativo",
  INACTIVE: "Inativo",
  REASON: "\nMotivo: ",

  EXPORT_CSV: "Exportar XLSX",
  CSV_HEADER: "Endereço,Tag,Modelo,Diagnósticos,Retentativas sem falhas,Retentativas totais,Falhas,Disponibilidade,Watchdog,Status\n",

  PAGE: "Página",

  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " mêses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",
  SECOND_T: " segundo",

  // ---------------------------- Log ----------------------------
  MANUFACTURER_MODEL: "Fabricante / Modelo",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",

  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILES_SUCCESS: "Os arquivos foram enviados com sucesso.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updatePRO.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",

  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configurações do servidor NTP enviadas.",

  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS: "O log foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  CLEAN_STATISTICS_SUCCESS: "As estatísticas foram limpadas com sucesso.",
  CLEAN_STATISTICS_FAILURE: "Ocorreu um erro ao limpar as estatísticas.",

  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do monitor",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SAME_SUBNET_IP_1: "\n- O endereço IP da interface WLAN não pode estar na mesma subrede da interface ETHERNET.",
  SAME_SUBNET_IP_2: "\n- O endereço IP da interface ETHERNET não pode estar na mesma subrede da interface WLAN.",
  SUBNET_OVERLAP_WLAN: "\n- O TS Monitor PROFIBUS PRO detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Monitor PROFIBUS PRO detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do TS Monitor PROFIBUS PRO",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do TS Monitor PROFIBUS PRO",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do TS Monitor PROFIBUS PRO",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",

  EMPTY_WIFI_PWD: "\n- A senha da Wi-fi não pode ser vazia",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  RESTART_SYSTEM: " Reiniciar sistema",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  SELECT_FILE: "Por favor selecione um arquivo para ser enviado",
  SELECT_GSD_FLIE: "Por favor selecione ao menos um arquivo GSD para ser enviado",
  SENDING_GSD_FILES: "Enviando arquivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no monitor. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o monitor, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o monitor: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do monitor foi modificada com sucesso.",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do monitor.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocorreu um erro ao enviar os seguintes arquivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocorreu um erro ao remover os seguintes arquivos GSD: ",

  MANAGE: "Gerenciar",

  TAG_CONFIG: "Tag da rede",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do monitor.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do monitor.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o monitor precisará ser reiniciado.",

  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  MONITOR_RESTART_SUCCESS: "O monitor foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o monitor.",

  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",

  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o monitor ou o roteador WLAN.",

  ALTER_MONITOR_CONFIG: "Tem certeza que deseja alterar as configurações do monitor?",
  IP: "IP",
  EDIT: "Editar",
  CLEAR: "Limpar",
  ALTER: "Alterar",
  REPORT: "Relatório",
  ALTER_LOGIN: "Alterar login",
  SEND: "Enviar",
  GSD_FILES: "Arquivos GSD",
  SOFTWARE_UPDATE: "Atualização de Software",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",

  TEST_NETWORK: "Rede de teste",
  USER: "Usuário",
  NEW_PASSWORD: "Nova senha",
  REPEAT_PASSWORD: "Repetir senha",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  FIXED_IP: "IP Fixo",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  CHANNEL: "Canal",
  QUALITY: "Qualidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualidade",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  GATEWAY: "Gateway",
  PASSWORD: "Senha",

  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do monitor?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do monitor.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o monitor está conectado ou não à rede WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o monitor por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Monitor PROFIBUS PRO não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mal contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mal contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  MAC: "MAC",
  DNS: "DNS",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Tem certeza que deseja alterar o hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para isso é necessário reiniciar o monitor.",
  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  NEW_TAG: "Nova TAG",
  SAVE: "Salvar",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  REMOVE: "Remover",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  IMPORT_TAGS_SUCCESS: "As tags foram importadas com sucesso",
  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  MASTER_HASH: "Mestre #",
  SLAVE_HASH: "Escravo #",

  // ---------------------------- Edit GSD page related ----------------------------
  REMOVE_GSD_SUCCESS: "Os arquivos GSD foram removidos com sucesso",
  REMOVE_GSD_FILES: "Gerenciar arquivos GSD",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione ao menos um arquivo para remover",
  REMOVING_GSD_FILES: "Removendo arquivos GSD",
  FILTER_GSD_FILES: "Filtrar arquivos GSD",

  SELECT_ALL: "Selecionar todos",
  REMOVE_SELECTED: "Remover selecionados",

  // ---------------------------- Blacklist page related ----------------------------
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Ocorreu um erro ao adicionar os escravos à blacklist.",

  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Ocorreu um erro ao remover os escravos da blacklist.",

  REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE: "Ocorreu um erro ao remover os escravos da lista de escravos críticos.",

  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por endereço, tag ou modelo",
  BLACKLIST_ADDRESS: "Endereço",
  BLACKLIST_TAG: "Tag",
  BLACKLIST_MODEL: "Modelo",
  BLACKLIST_CRITICAL_SLAVE: "Escravo crítico",
  UPDATE_BLACKLIST: "Atualizar blacklist",
  UPDATING_BLACKLIST_DATA: "Atualizando informações, aguarde",

  BLACKLIST_HEADER_CELL_POPUP: "Impede a gravação de logs de determinado equipamento a fim de não gerar eventos repetitivos ou indesejados.",
  BLACKLIST_HEADER_CELL_POPUP_2: "O escravo em Blacklist não altera o estado da rede na aba Resumo. Suas falhas, retentativas e diagnósticos são contabilizados.",

  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP: "Escravos que apresentam altas quantidades de eventos são inseridos automaticamente na lista de escravos críticos. Seus eventos deixam de ser salvos a fim de não saturar o log, mas suas falhas, retentativas e diagnósticos são contabilizados.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2: "O usuário pode remover escravos críticos, mas não inserí-los.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3: "Se existir ao menos um escravo crítico na lista, ele altera o estado da rede para ESCRAVO CRÍTICO na aba Resumo.",

  ADD_BLACKLIST_CONFIRM_TEXT: "Tem certeza que deseja realizar as alterações à blacklist e à lista de escravos críticos?",

  // ---------------------------- PDF Report ----------------------------
  PROFIBUS: "PROFIBUS",

  REPORT_EXPORT_NAME: "Relatório TS Monitor PROFIBUS PRO",
  HEADER_TEXT: "Relatório de dados - TS Monitor PROFIBUS PRO - Protocolo",

  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",
  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",

  CONFORMITY: "Conformidade",
  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  GENERATE_REPORT: "Gerar relatório",

  GENERAL_REPORT: "Relatório geral – TS Monitor PROFIBUS PRO",
  DATA_REPORT: "Relatório de dados – TS Monitor PROFIBUS PRO",

  MONITORING_INFO: "Informações do monitoramento",
  ETHERNET_INFO: "Informações ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme com restrições",
  NON_CONFORM_STRING: "Não conforme",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  NETWORK_NAME_DP: "- Nome da rede: ",
  TAG_NAME_DP: "- Tag da rede: ",
  MONITOR_VERSION_DP: "- Versão do monitor: ",
  MONITOR_INIT_DP: "- Inicio do monitoramento: ",
  GENERATING_TIME_DP: "- Geração do relatório: ",
  DURATION_SINCE_MON_BEGIN: "- Duração do monitoramento até a geração do relatório: ",

  TS_MONITOR_VER_DP: "TS Monitor PROFIBUS PRO - Versão ",
  NETWORK_AVAILABILITY_DP: "Disponibilidade da rede: ",
  BAUD_RATE_DP: "Baud rate: ",
  CYCLE_TIME_DP: "Tempo de ciclo: ",
  DEVICE_DATA: "Dados dos dispositivos",
  MASTERS_DP: "Mestres: ",
  SLAVES_DP: "Escravos: ",
  ONLINE_SLAVES_DP: "Escravos online: ",
  MISSING_DP: "Ausentes: ",
  RETRIES_DP: "Retentativas: ",
  DIAGNOSTIC_DP: "Diagnósticos: ",
  FAULT_DP: "Falhas: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Limite de retentativa: ",
  HSA_DP: "HSA: ",

  SUMMARY: "Sumário",
  RESUME: "Resumo",
  LIVE_LIST: "Live List",
  LOG: "Log",
  MATRIX: "Matriz",
  GRAPHIC_TOPOLOGY: "Topologia gráfica",
  CONFIG_STRING: "Configurações",

  RESUME_DOTS: ".......................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "...................................................................................................................................",

  M_MONITORING_RESUME_PAGE_TITLE: "1.1. - Resumo",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "1.2. Live List",
  M_MONITORING_LOG_PAGE_TITLE: "1.3. - Log",

  ADDRESS: "Endereço",
  MODEL: "Modelo",

  LAST_200_EVENTS: "200 últimos eventos",
  HORARY: "Horário",
  DESCRIPTION: "Descrição",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em PROFIBUS, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro certificado PROFIBUS ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  DIAGNOSTIC_STRING: "Diagnóstico",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Ausentes",
  MISSING_SINGULAR_STRING: "Ausente",
  CONFIG_ERROR_STRING: "Erro de configuração",
  PARAM_ERROR_STRING: "Erro de parametrização",
  FAULT_STRING: "Falha",
  BLACKLIST_STRING: "Blacklist",
  CRITIC_SLAVE_STRING: "Escravo crítico",
  MASTER_FAULT_STRING: "Mestre",
  SLAVE_MASTER_FAULT_STRING: "Mestre em falha",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI em falha",
  MASTER_CLASS_2: "Mestre",
  MASTER_OPERATE: "Mestre - operate",
  MASTER_SYNC: "Mestre - sync",
  MASTER_UNSYNC: "Mestre - unsync",
  MASTER_FREEZE: "Mestre - freeze",
  MASTER_UNFREEZE: "Mestre - unfreeze",
  MASTER_CLEAR: "Mestre - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Mestre - Operate",
  MASTER_SYNC_CAPITAL: "Mestre - Sync",
  MASTER_UNSYNC_CAPITAL: "Mestre - Unsync",
  MASTER_FREEZE_CAPITAL: "Mestre - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Mestre - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Mestre - Clear",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido em até 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "A rede possui escravos em diagnóstico",
  WITH_FAILURE_STRING: "A rede possui escravos em falha",
  WITH_CRITICAL_SLAVE_STRING: "A rede possui escravos em estado crítico",
  WITH_MASTER_FAULT_STRING: "A rede possui mestres em falha",
  UNKNOWN: "Desconhecido",
  LOG_WAITING: "Carregando dados do log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou status",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço, tag, modelo ou \"Evento da rede\"",
  OPTIC_FIBER_LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por tipo de evento",
  OPTIC_FIBER_INSERT_VALID_TYPE: "Favor digite um tipo de evento válido.",
  SLAVE_DIAGNOSTIC: "Diagnóstico do escravo:",
  STATUS_CHANGE: "Mudança de estado: ",
  NETWORK_EVENT: "Evento da rede",
  MASTER_HASHTAG: "Mestre #",
  CONFIG_ERROR_1: "Erro de ",
  CONFIG_ERROR_2: "configuração",
  PARAM_ERROR_1: "Erro de ",
  PARAM_ERROR_2: "parametrização",
  LAST_EVENT: "Último evento: ",
  MODEL_: "Modelo: ",

  DIAGNOSTICS_STRING: "Diagnósticos",
  RETRIES_STRING: "Retentativas",
  NO_FAULTS_STRING: "sem falhas",
  TOTAL: "totais",
  RETRIES_NO_FAULT_STRING: "Retentativas sem falhas",
  FAULTS_STRING: "Falhas",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Bilhão de",
  BILLIONS_OF: "Bilhões de",
  MILLION_OF: "Milhão de",
  MILLIONS_OF: "Milhões de",
  THOUSAND: "Mil",
  LAST_EVENT_TOO_BIG_STRING: "Descrição muito longa, favor consultar o log.",
  CRITICAL_SLAVE_EXPLANATION: "O TS monitor possui uma função automática de selecionar os escravos que possuam um número excessivo de eventos e informa ao usuário que este dispositivo é crítico à rede PROFIBUS.",
  DIAGNOSTICS_QUESTION_INFO: " Indica o número de diagnósticos detectados na rede PROFIBUS. Diagnósticos indicam condições anormais de estado do dispositivo, como curto-circuito, problema de alimentação, falta de módulo, etc.",
  RETRIES_QUESTION_INFO: "Indica o número de vezes que o mestre precisou reenviar ums mensagem para determinado equipamento após não receber resposta. Indica, usualmente, problemas no meio físico.",
  NOT_RETRIES_QUESTION_INFO: "A retentativa sem falha nos ajuda a verificar problemas de rede, que ainda não causaram a queda do dispositivo. Também, desconsidera as quedas que ocorreram por desligamento ou desconexão.",

  FAULTS_QUESTION_INFO: "Indica o número vezes que determinado equipamento PROFIBUS parou de responder mensagens do mestre.",

  WATCHDOG_QUESTION_INFO_1: "O watchdog é o tempo que o escravo aguarda após perder a comunicação com o mestre até modificar suas saídas para a condição de segurança.",
  WATCHDOG_QUESTION_INFO_2: "Este parâmetro é enviado pelo mestre a todos os escravos da rede, individualmente, em seu respectivo telegrama de parametrização.",
  WATCHDOG_QUESTION_INFO_3: "Se o tempo de ciclo estiver próximo ao watchdog a rede fica mais vulnerável.",
  WATCHDOG_QUESTION_INFO: "Indica se o watchdog para o dispositivo está ativo, inativo, ou se ainda não foi parametrizado.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Pesquisar device por endereço ou tag",

  EDIT_TOPOLOGY_POS_STRING: "Editar",
  EDIT_EDGE_TYPE: "Editar tipo de conexão",
  SAVE_TOPOLOGY_POS_STRING: "Salvar",
  DELETE_TOPOLOGY_POS_STRING: "Remover",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topologia",
  IMPORT: "Importar",
  IMPORT_TOPOLOGY: "Importar Topologia",
  POSITION: "Posição",
  EXPORT: "Exportar",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi salvo com sucesso!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao salvar o posicionamento da topologia: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi removido com sucesso!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao remover o posicionamento da topologia: ",

  ASK_REMOVE_POSITIONING: "Tem certeza que deseja remover o posicionamento salvo?",
  REMOVE_POSITIONING: "Remover posicionamento",

  YES: "Sim",
  NO: "Não",

  ALERT_NOT_POSSIBLE_TO_EDIT: "Não é possível editar dados do mestre",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "Não é possível editar os dados do TS Scope",
  ALERT_NOT_POSSIBLE_TO_DELETE: "Não é possível remover um device da live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor escolha um tipo de dispositivo",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor selecione um tipo de conexão",

  ADD_DEVICE: "Adicionar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de dispositivo",
  ADD_CONNECTION: "Adicionar conexão",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de conexão",
  EDIT_DEVICE: "Editar dispositivo",

  CANCEL: "Cancelar",
  ADD: "Adicionar",

  MASTER_NAME: "Mestre",
  SLAVE_NAME: "Escravo",
  SLAVE_PA_NAME: "Escravo PA",
  REPEATER_NAME: "Repetidor",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Link de fibra",
  ACTIVE_TERMINATION_NAME: "Terminador ativo",
  UNKNOWN_NAME: "Desconhecido",
  TS_MONITOR_NAME: "TS Monitor",
  TS_MONITOR_PRO_NAME: "TS Monitor PRO",
  MPI_NAME: "MPI",
  TS_SCOPE_DP_NAME: "TS Scope DP",
  TS_SCOPE_PA_NAME: "TS Scope PA",

  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Remover selecionado",
  LOCALE_BACK: "Voltar",
  LOCALE_ADD_NODE: "Adicionar dispositivo",
  LOCALE_ADD_EDGE: "Adicionar conexão",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexão",
  LOCALE_ADD_DESCRIPTION: "Clique em um espaço em branco para adicionar um novo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Clique em um dispositivo e arraste a conexão até outro dispositivo para conectá-los",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Clique nos pontos de controle e os arraste para um dispositivo para conectá-los",
  LOCALE_CREATE_EDGE_ERROR: "Não é possível criar conexão para um cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters não podem ser removidos",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters não podem ser editados",

  FORM_NO_DEVICE_FOUND_PREFIX: "O dispositivo de endereço ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " não foi encontrado",

  INSERT_VALID_ADDRESS_OR_TAG: "Favor digitar um endereço ou tag válidos",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Favor digitar um endereço, tag ou modelo válidos",

  POSITIONING_CONFLICT_1: "Há um conflito nas informações dos dispositivos de endereços:",
  POSITIONING_CONFLICT_2: "\nPor conta disso, suas posições e conexões voltarão ao estado padrão.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Posicionamentos e conexões retornados ao estado padrão com sucesso",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocorreu o seguinte erro ao retornar os posicionamentos e conexões ao estado padrão: ",

  TOPOLOGY_IMPORT_SUCCESS: "A topologia foi importada com sucesso!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocorreu um erro ao importar a topologia gráfica: ",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor selecione um arquivo de topologia.",

  COLORS_LABELS: "Legenda de cores",
  LABEL_SLAVE_OK_MASTER_OP: ": Escravo ok, e mestre em operate;",
  LABEL_MASTER_STOP_CLEAR: ": Mestre em STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Escravo em diagnóstico;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Escravo em falha, e mestre em falha;",
  LABEL_SLAVE_CONFIG_ERROR: ": Escravo com erro de configuração;",
  LABEL_SLAVE_PARAM_ERROR: ": Escravo com erro de parametrização;",
  LABEL_SLAVE_ONLINE: ": Escravo online;",
  LABEL_SLAVE_MISSING: ": Escravo ausente;",
  LABEL_SLAVE_MASTER_FAULT: ": Escravo com mestre em falha;",
  LABEL_SLAVE_BLACKLIST: ": Escravo na blacklist;",
  LABEL_CRITICAL_SLAVE: ": Escravo critico;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Dispositivo sem status.",

  DEVICE_TAG_NOT_FOUND: "Não foi encontrado nenhum dispositivo com a TAG: ",

  INSERT_VALID_ADDRESS_1_127: "Digite um endereço de escravo válido, entre 1 e 127.",
  DEVICE_WITH_ADDRESS: "O dispositivo de endereço ",
  WAS_SUCCESSFULLY_ADDED: " foi adicionado com sucesso.",
  WAS_SUCCESSFULLY_REMOVED: " foi removido com sucesso.",
  IS_ALREADY_IN_NETWORK: " já está na rede.",
  REMOVE_DEVICE_ERROR: "Ocorreu o seguinte erro ao tentar remover o dispositivo: ",

  TS_SCOPE_NOT_FOUND: "Não foi possível encontrar o TS Scope de IP:",
  INVALID_INSERTED_IP: "O IP inserido é inválido",
  TS_SCOPE_FETCH_SUCCESS: "Fetch do TS Scope deu certo",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  TS_EXPERT: "TS Expert",
  SETUP: "Configurar",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",

  CONFIG_RETRIES_LIST_HEADER: "Retentativas sem falha",
  CONFIG_RETRIES_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará as retentativas que não levaram a falha, por dispositivo. A retentativa sem falha nos ajuda a verificar problemas de rede, que ainda não causaram a queda do dispositivo. Também, desconsidera as quedas que ocorreram por desligamento ou desconexão.",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnósticos",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os diagnósticos, por dispositivo.",

  CONFIG_FAULT_LIST_HEADER: "Falhas",
  CONFIG_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todas as falhas, por dispositivo.",

  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Sequência de falhas",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as falhas que ocorreram em sequência em caso de falhas de diversos dispositivos.",

  CONFIG_CONFIG_ERROR_LIST_HEADER: "Erro de configuração",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os dispositivos que apresentam erro de configuração.",

  CONFIG_PARAM_ERROR_LIST_HEADER: "Erro de parametrização",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os dispositivos que apresentam erro de parametrização.",

  CONFIG_MISSING_LIST_HEADER: "Escravo ausente",
  CONFIG_MISSING_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os escravos ausentes.",

  CONFIG_ONLINE_LIST_HEADER: "Escravo online",
  CONFIG_ONLINE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os escravos online.",

  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Escravo crítico",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todos os escravos críticos.",

  CONFIG_MASTER_FAULT_LIST_HEADER: "Mestre em falha",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará quando o TS Monitor não estiver recebendo frames PROFIBUS.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Link de fibra ótica – Falha no nível de tensão (Ação Requerida)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará baixa tensão nas saídas analógicas que indicam a qualidade do sinal recebido pelo link de fibra. Este valor pode ser configurado pelo usuário na tela de configuração do seu TS Scope/Monitor PRO.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Link de fibra ótica – Falha no nível de tensão (Ação Urgente)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará baixa tensão nas saídas analógicas que indicam a qualidade do sinal recebido pelo link de fibra. Este valor pode ser configurado pelo usuário na tela de configuração do seu TS Scope/Monitor PRO.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Link de fibra ótica – Falha por relé",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "Quando ativada esta opção, o TS Expert mostrará falha no link de fibra indicada por relé, que deve estar conectado ao TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - Monitor PROFIBUS PRO",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Monitor em redes PROFIBUS.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",

  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",

  PROBLEM_CHECKED: "O evento foi conferido com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao conferir o evento.",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  DEVICE: "Dispositivo",

  // ---------------------------- RETRIES (TS EXPERT) ----------------------------
  RETRIES_LIST_HEADER: "Existem dispositivos na rede que possuem retentativas sem falhas.",
  DEVICE_WITH_RETRIES: "Dispositivo com retentativas sem falhas",

  RETRIES_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem retentativas:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois eles ainda possui retentativas\n",

  RETRIES_SUGGESTION_1: "Quando um dispositivo possuir retentativas sem falhas sugere-se:",
  RETRIES_SUGGESTION_2: "As retentativas sem falhas indicam o número de vezes que o mestre precisou reenviar uma mensagem para determinado equipamento após não receber resposta, seja porque o escravo não respondeu ou porque a resposta estava corrompida (frame ilegal ou incompleto), por efeito de ruido, baixo isolamento em escravo ou na infraestrutura do barramento. A retentativa sem falha nos ajuda a verificar problemas de rede, que ainda não causaram a queda do dispositivo. Também, desconsidera as quedas que ocorreram por desligamento ou desconexão.",
  RETRIES_SUGGESTION_3: "Verificar e corrigir a montagem do conector. O TDC-1000 pode lhe ajudar nesta tarefa;",
  RETRIES_SUGGESTION_4: "Verificar danos ao cabo PROFIBUS, como:",
  RETRIES_SUGGESTION_5: "Dobras menores que 10 vezes o raio do condutor;",
  RETRIES_SUGGESTION_6: "Cortes no cabo;",
  RETRIES_SUGGESTION_7: "Torções no cabo;",
  RETRIES_SUGGESTION_8: "Amassados no cabo.",
  RETRIES_SUGGESTION_9: "Estas não conformidades exigem a troca do trecho de cabo (não é possível solucionar a não conformidade desdobrando ou desamassando o cabo);",
  RETRIES_SUGGESTION_10: "Verifique se há cabos de potência próximos a cabos PROFIBUS. Cabos de dados como o PROFIBUS devem estar separados o mais distante possível ou em eletrocalhas/eletrodutos fechados e aterrados, seguindo o mínimo indicado pelas diretrizes de acordo com a classificação do condutor elétrico, norma EN50174;",
  RETRIES_SUGGESTION_11: "Medir corrente de fuga no cabo com um alicate adequado, se medida for maior que 100mA é necessário conferir a equipotencialização e o sistema de aterramento;",
  RETRIES_SUGGESTION_12: "Verificar a qualidade do sinal com um dos equipamentos da Toledo e Souza que possua osciloscópio, que lhe dará dicas segundo as medições realizadas;",
  RETRIES_SUGGESTION_13: "Caso nenhum dos itens acima resolva, e um determinado equipamento esteja apresentando retentativas isoladamente (apenas um determinado escravo apresenta retentativas), sugere-se substituir a interface de rede do escravo.",
  RETRIES_SUGGESTION_14: "O único item que pode ter melhor resultado com a planta rodando é o item “d”, porém o uso do equipamento da Toledo e Souza que possui osciloscópio deve ser realizado com cautela, pois caso a condição sinal esteja muito comprometida pode derrubar a rede.",

  // ---------------------------- DIAGNOSTIC (TS EXPERT) ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Existem dispositivos na rede que possuem diagnósticos.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo com diagnósticos",

  DIAGNOSTIC_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem diagnósticos:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui diagnósticos\n",

  DIAGNOSTIC_SUGGESTION_1: "Quando um dispositivo possuir diagnósticos sugere-se:",
  DIAGNOSTIC_SUGGESTION_2: "O estado “Diagnóstico” é uma informação enviada pelo escravo ao mestre, geralmente não é um problema de rede e sim um aviso do escravo que ele está precisando de manutenção ou substituição. Abaixo a lista de ações para resolver o problema:",
  DIAGNOSTIC_SUGGESTION_3: "Caso um escravo apresente diagnóstico verifique a informação enviada e tente solucionar o problema, caso tenha dificuldade em entender o diagnóstico entre em contato com o fabricante do escravo para sanar suas dúvidas antes de uma intervenção;",
  DIAGNOSTIC_SUGGESTION_4: "O número crescente de diagnóstico sem dados de manutenção pode estar ligado diretamente as falhas do dispositivo, pois quando o equipamento volta a comunicar existe um diagnóstico de conferência, que verifica se o escravo está pronto para troca de dados. Verifique se o número de diagnóstico está próximo ao de falhas, neste caso siga o passo-a-passo de testes para falhas.",

  // ---------------------------- FAULT (TS EXPERT) ----------------------------
  FAULT_LIST_HEADER: "Existem dispositivos na rede que possuem falhas.",
  DEVICE_WITH_FAULT: "Dispositivo com falhas",

  FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem falhas:\n",
  S_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui falhas\n",

  FAULT_SUGGESTION_1: "Quando um dispositivo possuir falhas sugere-se:",
  FAULT_SUGGESTION_2: "O estado “Falha” indica que o escravo parou de comunicar, ou seja deixou de trocar dados com o mestre (caiu da rede). Neste caso não há como determinar o motivo da falha, que pode ser, por exemplo, o rompimento de um cabo ou falta de alimentação elétrica:",
  FAULT_SUGGESTION_3: "Verificar a alimentação do escravo;",
  FAULT_SUGGESTION_4: "Verificar se está conectado à rede (cabo ou fibra óptica);",
  FAULT_SUGGESTION_5: "Verificar a integridade e correta montagem do conector;",
  FAULT_SUGGESTION_6: "Verificar a integridade do cabo;",

  // ---------------------------- FAULT SEQUENCE (TS EXPERT) ----------------------------
  FAULT_SEQ_LIST_HEADER: "Existem dispositivos na rede que possuem sequências de falhas.",
  DEVICE_WITH_FAULT_SEQ: "Dispositivo com sequência de falhas",

  FAULT_SEQ_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem sequência de erros:\n",
  S_FAULT_SEQ_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui sequência de erros\n",

  FAULTS_SEQ_SUGGESTION_1: "No caso de uma falha de dispositivos em sequência sugere-se:",
  FAULTS_SEQ_SUGGESTION_2: "Verificar a alimentação dos escravos que pararam de comunicar;",
  FAULTS_SEQ_SUGGESTION_3: "Verificar a qualidade do sinal no segmento do primeiro escravo que parou de comunicar com um dos equipamentos da Toledo e Souza que possua osciloscópio;",
  FAULTS_SEQ_SUGGESTION_4: "Verificar se estão conectados à rede;",
  FAULTS_SEQ_SUGGESTION_5: "Verificar se algum terminador isolador foi ligado acidentalmente;",
  FAULTS_SEQ_SUGGESTION_6: "Verificar os terminadores de rede deste segmento;",
  FAULTS_SEQ_SUGGESTION_7: "Verificar a integridade do barramento deste segmento;",
  FAULTS_SEQ_SUGGESTION_8: "Verificar falhas potenciais em repetidores, hubs ou links de fibra óptica.",

  // ---------------------------- CONFIG ERROR (TS EXPERT) ----------------------------
  CONFIG_ERROR_LIST_HEADER: "Existem dispositivos na rede com erro de configuração.",
  DEVICE_WITH_CONFIG_ERROR: "Dispositivo com erro de configuração",

  CONFIG_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda apresentam erro de configuração:\n",
  S_CONFIG_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda apresenta erro de configuração\n",

  CONFIG_ERROR_SUGGESTION_1: "Quando um dispositivo possuir erro de configuração sugere-se:",
  CONFIG_ERROR_SUGGESTION_2: "Ocorre quando o algum escravo que não aceitou a configuração feita no mestre ou SDCD e não entrou em troca de dados, sugestão:",
  CONFIG_ERROR_SUGGESTION_3: "Verifique a configuração no software do mestre ou SDCD;",

  // ---------------------------- PARAM ERROR (TS EXPERT) ----------------------------
  PARAM_ERROR_LIST_HEADER: "Existem dispositivos na rede com erro de parametrização.",
  DEVICE_WITH_PARAM_ERROR: "Dispositivo com erro de parametrização",

  PARAM_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda apresentam erro de parametrização:\n",
  S_PARAM_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do seguinte dispositivo, pois ele ainda apresenta erro de parametrização\n",

  PARAM_ERROR_SUGGESTION_1: "Quando um dispositivo estiver com erro de parametrização sugere-se:",
  PARAM_ERROR_SUGGESTION_2: "Ocorre quando o algum escravo que não aceitou a parametrização feita no mestre ou SDCD e não entrou em troca de dados. A parametrização é uma conferência de ID Number do escravo, ou seja, pode ser que tenha sido instalado um escravo diferente do declarado no sistema. Sugestão:",
  PARAM_ERROR_SUGGESTION_3: "Verifique se o escravo declarado no software do mestre ou SDCD é o mesmo do instalado em campo.",

  // ---------------------------- MISSING (TS EXPERT) ----------------------------
  MISSING_LIST_HEADER: "Existem dispositivos ausentes na rede.",
  DEVICE_MISSING: "Dispositivo ausente",

  MISSING_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão ausentes:\n",
  S_MISSING_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda está ausentes\n",

  MISSING_SUGGESTION_1: "Quando um dispositivo estiver ausente sugere-se:",
  MISSING_SUGGESTION_2: "Ocorre quando o mestre ou SDCD está buscando um escravo na rede mas não recebe resposta. Este escravo foi configurado no projeto, mas não está respondendo na rede ou não esta instalado. Sugestão:",
  MISSING_SUGGESTION_3: "Verifique se o escravo declarado no software do mestre ou SDCD está conectado à rede e alimentado.",
  MISSING_SUGGESTION_4: "Não é indicado deixar o mestre ou SDCD buscando escravos que não serão instalados.",

  // ---------------------------- ONLINE (TS EXPERT) ----------------------------
  ONLINE_LIST_HEADER: "Existem dispositivos online na rede.",
  DEVICE_ONLINE: "Dispositivo online",

  ONLINE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão online:\n",
  S_ONLINE_INITIAL_ERROR_MSG: "Não foi possível conferir o eventos do dispositivo, pois ele ainda está online\n",

  ONLINE_SUGGESTION_1: "Quando um dispositivo estiver online sugere-se:",
  ONLINE_SUGGESTION_2: "Ocorre quando o mestre ou SDCD encontra um escravo na rede, mas ele não está configurado no sistema. Sugestão:",
  ONLINE_SUGGESTION_3: "Verifique se o escravo deveria estar fora da rede ou se deve ser configurado.",

  // ---------------------------- CRITICAL SLAVE (TS EXPERT) ----------------------------
  CRITICAL_SLAVE_LIST_HEADER: "Existem escravos críticos na rede.",
  DEVICE_IS_CRITICAL_SLAVE: "Dispositivo é um escravo crítico",

  CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda são escravos críticos:\n",
  S_CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda é um escravo crítico\n",

  CRITICAL_SLAVE_SUGGESTION_1: "Quando existirem escravos críticos na rede sugere-se:",
  CRITICAL_SLAVE_SUGGESTION_2: "O TS monitor possui uma função automática de selecionar os escravos que possuam um número excessivo de eventos, e informa ao usuário que este dispositivo é crítico à rede PROFIBUS. Sugestão:",
  CRITICAL_SLAVE_SUGGESTION_3: "Verifique a condição de instalação do escravo;",
  CRITICAL_SLAVE_SUGGESTION_4: "Verificar a alimentação do escravo;",
  CRITICAL_SLAVE_SUGGESTION_5: "Verificar se está conectado à rede de modo correto;",
  CRITICAL_SLAVE_SUGGESTION_6: "Verificar a integridade e correta montagem do conector;",
  CRITICAL_SLAVE_SUGGESTION_7: "Verificar a integridade do cabo;",
  CRITICAL_SLAVE_SUGGESTION_8: "Verificar a condição de qualidade do sinal do escravo com um dos equipamentos da Toledo e Souza que possua osciloscópio;",
  CRITICAL_SLAVE_SUGGESTION_9: "Caso a análise pelo equipamento com osciloscópio não traga a solução, sugere-se substituir a interface de rede.",
  CRITICAL_SLAVE_SUGGESTION_10: "Para retirar o escravo deste estado é necessário entrar em configurações, depois em blacklist e deselecionar o checkbox.",

  // ---------------------------- MASTER FAULT (TS EXPERT) ----------------------------
  MASTER_FAULT_LIST_HEADER: "Existem mestres em falha na rede.",
  DEVICE_IS_MASTER_FAULT: "Dispositivo é um mestre em falha",

  MASTER_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles não estão recebendo frames PROFIBUS:\n",
  S_MASTER_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele não está recebendo frames PROFIBUS\n",

  MASTER_FAULT_SUGGESTION_1: "Quando existirem mestre em falha na rede sugere-se:",
  MASTER_FAULT_SUGGESTION_2: "Ocorre quando o TS Monitor PROFIBUS PRO para de ler a rede. Sugestão:",
  MASTER_FAULT_SUGGESTION_3: "Verifique se houve uma falha geral na rede;",
  MASTER_FAULT_SUGGESTION_4: "Verifique se o TS Monitor foi isolado da rede;",
  MASTER_FAULT_SUGGESTION_5: "Verifique se o TS Monitor está corretamente conectado à rede PROFIBUS.",

  VOLTAGE_: "Tensão",
  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG: "Não foi possível conferir os eventos, pois o link de fibra ótica ainda está com falha no nível de tensão.",
  S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG: "Não foi possível conferir o evento, pois o link de fibra ótica ainda está com falha no nível de tensão.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "Quando for detectado link de fibra ótica com falha no nível de tensão sugere-se verificar visualmente:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "Sugere-se consultar o manual do fabricante do link de fibra para conferir o nível de tensão adequado.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG: "Não foi possível conferir os eventos, pois o link de fibra ótica ainda está com falha grave no nível de tensão.",
  S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento, pois o link de fibra ótica ainda está com falha grave no nível de tensão.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "Quando for detectado link de fibra ótica com falha grave no nível de tensão sugere-se verificar visualmente:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "Sugere-se consultar o manual do fabricante do link de fibra para conferir o nível de tensão adequado.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_ERROR_MSG: "Não foi possível conferir os eventos, pois ainda está sendo detectado sinal de falha por relé do link de fibre ótica.",
  S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG: "Não foi possível conferir o evento, pois ainda está sendo detectado sinal de falha por relé do link de fibre ótica.",

  FIBER_SIGNAL_LOSS_SUGGESTION_1: "Quando for detectado sinal de falha por relé do link de fibra ótica sugere-se verificar visualmente:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_RETRIES_DOTS: "....................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: "......................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: ".........................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: ".....................................................................................",
  DEVICE_MISSING_DOTS: ".......................................................................................................................",
  DEVICE_ONLINE_DOTS: "..........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "..................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "...............................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "......................................................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "............................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "................................................",
  FIBER_SIGNAL_LOSS_DOTS: "............................................................................................",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Link de fibra ótica – Falha no nível de tensão (Ação Requerida)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Link de fibra ótica – Falha no nível de tensão (Ação Urgente)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Link de fibra ótica – Falha por relé",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha no nível de tensão.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha no nível de tensão.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha por relé",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Fibra Ótica",
  RELAY_STATUS: "Status do relé",
  RELAY_SIGNAL: "Sinal do relé",
  MIN: "Mínimo",
  MAX: "Máximo",
  FAULT: "Falha",
  OK: "OK",
  MIN_ANALOG_VALUE: "Valor mínimo analógico",
  MIN_LIMIT_NOT_VALID: "O valor mínimo analógico não é válido",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Valor de Manutenção Urgente",
  MAINTENANCE_REQUIRED: "Valor de Manutenção Requerida",
  DIVERGENCE_MAINTENANCE_VALUE: "O Valor de manutenção requerida não pode ser menor que o de manutenção urgente!",
  INVALID_VALUE: "Valor Invalido",
  STR_LIMIT: "Até",
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",
  CHANNEL_5: "Canal 5",
  ERROR_REASON: "\nMotivo: ",

  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // ------------------------------------------------------ MEIO FÍSICO DP -------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------

  /// ---------------------------- Menu Bar ------------------------- 
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscópio",
  BAR_GRAPH: "Gráfico de barras",
  INFOS: "Agenda",
  CONFIG: "Configurações",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Bom",
  ATTENTION_STRING: "Atenção",
  BAD_STRING: "Ruim",
  NO_SIGNAL_STRING: "Sem sinal",
  UNKNOWN_STRING: "Desconhecido",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_DP: "Filtrar por endereço ou sinal",

  ADDRESSES: "Endereços",
  AMPLITUDE: "Amplitude",
  AMPLITUDE_PRE: "Amplitude preâmbulo",
  MEAN_AMPLITUDE: "Amplitude média",
  MEAN_AMPLITUDE_N: "Amplitude\nmédia",
  MIN_AMPLITUDE: "Amplitude mínima",
  MIN_AMPLITUDE_N: "Amplitude\nmínima",
  MAX_AMPLITUDE: "Sobressinal",
  NOISE: "Ruído",
  SIGNAL: "Sinal",
  RATIO: "Razão",
  NETWORK_TAG: "Tag do segmento",
  IS_IN_SEGMENT: "Pertence ao\nSegmento?",
  IS_IN_SEGMENT_1: "Pertence ao",
  IS_IN_SEGMENT_2: "Segmento?",
  IS_IN_SEGMENT_DP: "Pertence ao Segmento: ",
  IS_IN_SEGMENT_QUESTION: "Pertence ao Segmento?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indica se o dispositivo pertence ao mesmo segmento que este TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "Esta opção deve ser ajustada manualmente para cada dispositivo na tela de configurações.",

  MIN_AMPLITUDE_1: "Amplitude",
  MIN_AMPLITUDE_2: "mínima",

  MEAN_AMPLITUDE_1: "Amplitude",
  MEAN_AMPLITUDE_2: "média",

  RESPONSE_TIME_1: "Tempo de",
  RESPONSE_TIME_2: "resposta",
  CURRENT: "atual",
  MINIMUM: "mínimo",
  MAXIMUM: "máximo",

  RESPONSE_TIME: "Tresp.\natual",
  MIN_RESPONSE_TIME: "Tresp.\nmínimo",
  MAX_RESPONSE_TIME: "Tresp.\nmáximo",

  T_RESP: "T. Resp.",
  RESPONSE_TIME_POPUP: " é o tempo de resposta do escravo, variações podem indicar problemas no hardware dos dispositivos.",
  MAX_RESPONSE_TIME_POPUP: "Maior tempo de resposta registrado, variações podem indicar problemas no hardware dos dispositivos.",
  MIN_RESPONSE_TIME_POPUP: "Menor tempo de resposta registrado, variações podem indicar problemas no hardware dos dispositivos.",

  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Esta coluna é um indicador de problemas no canal A, fio verde, tais como:",
  CHANNEL_B_PROBLEM: "Esta coluna é um indicador de problemas no canal B, fio vermelho, tais como:",
  AMPLITUDE_IDLE: "Tensão no idle ",

  NETWORK_DATA: "Dados da rede",

  MODAL_TITLE: "Formas de onda caracteristicas",

  TURNED_ON: "Ligada",
  TURNED_OFF: "Desligada",

  ANALYSIS_ERROR: "Ocorreu um erro ao alterar o estado da análise",

  ANALYSIS: "Análise",
  ANALYZER: "TS Scope DP ",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Monitor PROFIBUS PRO não encontrado, por favor conecte-o ao computador.",
  INVERTED_AB: "Os cabos A e B estão invertidos.",
  MONGO_OFF: "Erro na base de dados, feche o programa e abra novamente. Se o erro persistir clique no botão abaixo.",
  PICO_NOT_FOUND: "O TS Monitor PROFIBUS PRO está desconectado. Após reconectá-lo, é necessário reiniciar o programar.",
  MONGO_REPAIR_SUCCESS: "Erro reparado com sucesso! Por favor feche o programa e abra novamento para que as alterações tenham efeito.",
  MONGO_REPAIR_ERROR: "Não foi possível solucionar o problema. Por favor entre em contato para receber suporte.",
  INIT_PICO_NOT_FOUND_PLAY: "Erro ao iniciar o TS Monitor PROFIBUS PRO. Por favor desconecte-o do seu computador, conecte novamente, e reinicie o programa. Caso o erro persista, reinicie o computador e tente novamente.",

  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando TS Monitor PROFIBUS PRO por favor aguarde.",

  NO_DP_ACTIVE_NETWORK: "O TS Monitor PROFIBUS PRO não encontrou uma rede ativa, certifique-se de que está conectado corretamente a uma rede PROFIBUS DP e tente novamente.",

  INVALID_SERIAL: "O número de série não corresponde a este TS Monitor PROFIBUS PRO. Por favor reinstale o programa com um número de série válido.",
  INVERTED_AB_POPUP: "Os cabos A e B estão invertidos.\nPor favor desinverta os cabos e aperte Play novamente.",

  MONGO_OFF_POPUP: "Erro ao inicializar a base de dados, clique no botão abaixo para reparar o problema.",

  MEAN_AMPLITUDE_DESC: "Valor de amplitude medido entre a média dos pontos em nível lógico alto e a média dos pontos em nível lógico baixo, como ilustra a figura abaixo.",
  MEAN_AMPLITUDE_DESC_2: "A amplitude média alta é um indicativo de falta de terminadores. Já quando esta baixa indica: Resistência nas conexões; excesso de terminadores; cabos prensados; cabos amassados ou dobrados etc.",
  AMPLITUDE_MIN_DESC: "Valor de amplitude entre o menor ponto da forma de onda em nível lógico alto e o maior ponto em nível lógico baixo, como ilustra a figura abaixo.",
  AMPLITUDE_MIN_DESC_2: "Uma diferença grande entre a amplitude média e a mínima indica: Reflexão (terminadores); cabo longo; ruído; umidade no barramento etc.",
  OVERSHOOTING_DESC: "Valor de amplitude entre o valor médio da forma de onda em nível lógico alto e o maior ponto em nível lógico alto, como ilustra a figura abaixo.",
  OVERSHOOTING_DESC_2: "Indica: Falta de terminadores; conexões no meio do barramento; derivações etc.",
  RATIO_DESC_1: "Razão entre os valores de amplitude mínima e amplitude média, com o intuito de deixar evidente a degradação do sinal.",
  RATIO_DESC_2: "Quanto mais próximo de 1 melhor, e quanto mais próximo de 0 (zero) pior a qualidade do sinal.",
  RATIO_FOMULA: "Razão = Amp. mínima / Amp. média",

  IDLE_DESCRIPTION: " Período em que a rede está ociosa, ou seja, é o período entre uma pergunta do mestre e a resposta do escravo,  ou entre pacotes do mestre para ele mesmo. A tensão ideal do idle é de 1V, valores diferentes indicam problemas na rede.",
  IDLE_DESCRIPTION_2: "Caso a tensão no idle seja menor que 0,6 V o valor será destacado em laranja.",

  MONITOR_IP_NOT_FOUND: "IP do monitor não encontrado",

  CHANNEL_DESCRIPTION_1: "Curto-circuito",
  CHANNEL_DESCRIPTION_2: "Borne frouxo",
  CHANNEL_DESCRIPTION_3: "Cabo rompido",
  CHANNEL_DESCRIPTION_4: "Ou outro problema que danifique o sinal de comunicação.",

  SIGNAL_QUALITY: "Qualidade do sinal",
  SIGNAL_QUALITY_DESCRIPTION_1: "Na coluna “Sinal” sempre é considerado o pior caso, para Amplitude média e mínima.",

  GOOD: "Bom",
  GOOD_DESCRIPTION_1: "• Amplitude Média de 4 a 7 V",
  GOOD_DESCRIPTION_2: ". Sinal com boa amplitude!",

  ATTENTION: "Atenção - Ação preventiva",
  ATTENTION_DESCRIPTION_1: "• Amplitude média de 7 a 8 V",
  ATTENTION_DESCRIPTION_2: ". Pode indicar falta de terminadores.",
  ATTENTION_DESCRIPTION_3: "• Amplitude média de 3 a 4 V",
  ATTENTION_DESCRIPTION_4: ". Pode indicar resistência no barramento, muitos terminadores, problemas de conexão, bornes frouxos, problema em escravo etc.",

  BAD: "Ruim - Ação corretiva",

  BAD_DESCRIPTION_1: "• Amplitude média menor que 3 V",
  BAD_DESCRIPTION_2: " ou maior que 8 V",
  BAD_DESCRIPTION_3: ", pode causar perda de pacotes PROFIBUS.",
  BAD_DESCRIPTION_4: "• Amplitude mínima menor que 3 V",
  BAD_DESCRIPTION_5: " pode causar perda de pacotes PROFIBUS.",

  LIGHT_TONES: "Tons claros",
  LIGHT_TONES_DESCRIPTION: "• O TS Monitor PROFIBUS PRO não está encontrando resposta do escravo, portanto o software mantém as medições da última captura e deixa o tom claro indicando que não esta atualizando os dados.",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  A_AND_B: "A e B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DP: "Endereço: ",
  WAVE_A: "Sinal A",
  WAVE_B: "Sinal B",
  WAVE_B_A: "Sinal B - A",
  WAVE_PA: "Sinal PA",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Tempo (ns)",
  TIME_US: "Tempo (μs)",
  TIME_MS: "Tempo (ms)",
  TIME_S: "Tempo (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tempo",
  CONTROLS_POPUP_TEXT: "Após apertar PLAY, a forma de onda é atualizada aproximadamente a cada 200 milissegundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar os controles é preciso selecionar a visualização manual e escolher um dispositivo.",

  SIZE: "Tamanho ",
  VISUALIZATION: "Visualização",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  STD_WAVE_FORM: "Forma de onda padrão",
  LONG_CABLE_WAVE_FORM: "Forma de onda típica de cabo longo",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda típica de excesso de terminador",
  NO_SLAVE_WAVE_FORM: "Forma de onda típica de ausência de escravo (dispositivos desconectados)",
  REFLECTION_WAVE_FORM: "Forma de onda típica com reflexão",
  NO_TERMINATOR_WAVE_FORM: "Forma de onda típica de falta de terminador",
  FOR_MORE_INFO_DP: "Para informações adicionais, consulte a Toledo & Souza ou as diretrizes da PROFIBUS International. Vale ressaltar que os eventos demonstrados podem acontecer em conjunto o que muda o padrões demonstrados.",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de pouco terminador",

  WAVE_SIZE_DESC_1: "O TS Monitor PROFIBUS PRO já amostra o frame de dois modos com apenas 1 Byte ou com 3 Bytes, de tal modo que aqui conseguimos visualizar com um zoom maior em 1 Byte ou um zoom menor em 3 Bytes.",
  WAVE_SIZE_DESC_2: "Existe uma exceção: O frame “E5” – short acknowledgement – só tem 1 Byte, sempre.",
  WAVE_SIZE_DESC_3: "Abaixo um exemplo em um frame com mais de 1 e 3 Bytes.",

  TS_SCOPE_NOT_FINDING_ANSWER: "O TS Monitor PROFIBUS PRO não está encontrando resposta do escravo, portanto os dados estão desatualizados. A forma de onda abaixo é a última capturada pelo sistema.",

  TIME_DP: "Tempo: ",
  PS_1: "Obs 1:",
  PS_2: "Obs 2:",
  PS_3: "Obs 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Classificar por",
  AMPLITUDE_ASC: "Amplitude crescente",
  AMPLITUDE_DESC: "Amplitude decrescente",
  ADDRESS_ASC: "Endereço crescente",
  VOLTAGE_V: "Tensão (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensão (V)",
  VOLTAGE_MV: "Tensão (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Tensão (mV)",
  ORDER: "Ordenação",
  REFRESH_DATA: "Atualizar dados",
  LOADING: "Carregando",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_TYPE: "Favor digite um tipo de evento válido.",
  LOG_INPUT_TEXT_PLACEHOLDER_DP: "Filtrar por tipo de evento",
  TYPE: "Tipo",

  TERMINATION_OFF_LOG_DESCRIPTION: "O TS Expert detectou uma possível falta de terminador na rede.",
  NO_TERMINATION_LOG_DESCRIPTION: "O TS Expert detectou uma possível ausência de terminador no segmento ao qual está conectado.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "O TS Expert detectou possível falta de alimentação no terminador.",
  HIGH_RESISTANCE_LOG_DESCRIPTION: "O TS Expert detectou um possível excesso de terminadores ou alta resistência no barramento PROFIBUS.",
  A_NOT_OK_LOG_DESCRIPTION: "O TS Expert detectou possível curto-circuito entre o condutor A e a malha de blindagem, ou a massa aterrada de um painel ou escravo.",
  B_NOT_OK_LOG_DESCRIPTION: "O TS Expert detectou possível curto-circuito entre o condutor B e a malha de blindagem, ou a massa aterrada de um painel ou escravo.",
  LONG_CABLE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de barramento com comprimento maior do que o permitido.",
  NOISE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de ruído na rede PROFIBUS.",
  REFLECTION_LOG_DESCRIPTION: "O TS Expert detectou a presença de reflexão na forma de onda.",
  DEFORMED_WAVE_LOG_DESCRIPTION: "O TS Expert detectou a presença de sinal fora do padrão.",
  DUPLICATE_LOG_DESCRIPTION: "O TS Expert detectou possível presença de dois escravos com o mesmo endereço na rede.",
  EVENT_CHECKED_SUCCESS: "O evento foi conferido com sucesso.",
  OPTIC_FIBER_EVENT_CHECKED_SUCCESS: "O evento foi limpo com sucesso.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME_DP: "Relatório TS Monitor PROFIBUS PRO - Meio Físico DP",
  HEADER_TEXT_DP: "Relatório de dados - TS Monitor PROFIBUS PRO - Meio Físico DP",

  ANALYZER_VERSION_STRING: "- Versão do monitor:",
  ANALYZER_VERSION: "4.0.0",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "PROFIBUS DP",

  ANALYSIS_INIT: "- Início do monitoramento:",
  REPORT_GENERATION: "- Geração do relatório:",
  ANALYSIS_DURATION: "- Duração do monitoramento até a geração do relatório: ",

  REPORT_TYPE: "Tipo de Relatório",

  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme com restrições",
  NON_CONFORM: "Não conforme",

  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Osciloscópio",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Gráfico de barras",
  A_LOG_PAGE_TITLE: "4. - Log de eventos",

  B_LIVE_LIST_PAGE_TITLE: "2.1. - Live List",
  B_OSCILLOSCOPE_PAGE_TITLE: "2.2. - Osciloscópio",
  B_BAR_GRAPH_PAGE_TITLE: "2.3. - Gráfico de barras",
  B_LOG_PAGE_TITLE: "2.4. - Log de eventos",

  ANALYSIS_INFO: "Informações do monitoramento",
  GENERATED_BY: "- Gerado por TS Monitor PROFIBUS PRO",
  HARDWARE_VERSION: "- Versão de hardware:",
  SOFTWARE_VERSION: "- Versão de software:",
  DATE_TIME: "- Data e hora:",
  BAUD_RATE: "- Baud rate:",
  CYCLE_TIME: "- Tempo de ciclo:",
  NUM_MASTERS: "- Mestres:",
  NUM_SLAVES: "- Escravos:",
  AMPLITUDE_IDLE_1: "- Tensão no idle:",
  SEGMENT_TAG: "- Tag do segmento: ",

  LIVE_LIST_DOTS_DP: "........................................................................................................................................",
  BAR_DOTS_DP: ".........................................................................................................................",
  OSC_DOTS_DP: "................................................................................................................................",
  LOG_DOTS_DP: "................................................................................................................................................",
  DISCLAIMER_DOTS_DP: "....................................................................................................................................",

  SELECT_REPORT_TYPE: "Por favor selecione um tipo de relatório",

  MASTER_DP: "Mestre: ",
  SLAVE_DP: "Escravo: ",
  SIGNAL_DP: "Sinal: ",
  AMPLITUDE_DP: "Amplitude: ",
  AMPLITUDE_PRE_DP: "Amplitude preâmbulo: ",
  AMPLITUDE_MIN_DP: "Amplitude mínima: ",
  OVERSHOOTING_DP: "Sobressinal: ",
  AMPLITUDE_MAX_DP: "Amplitude máxima: ",

  GENERAL_INFORMATION: "Informações gerais",

  CAPTURE_TIME: "Horário da captura",

  PROJECT_NAME_LABEL: "Nome do projeto",
  NETWORK_LABEL: "Nome da rede",
  LOCATION_LABEL: "Localização",
  COMPANY_NAME_LABEL: "Nome da empresa",
  ACCOUNTABLE_NAME_LABEL: "Nome do responsável",
  CITY_LABEL: "Cidade",
  TEL_LABEL: "Telefone",
  CLIENT_LOGO_LABEL: "Logo do cliente",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo da empresa executora",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Salvar relatório",
  SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM: "Não foi possível encontrar o escravo na rede, mostrando última forma de onda capturada.",
  REPORT_MN_PB_PRO_FULL: "Relatório - TS Monitor PROFIBUS PRO - Completo",
  REPORT_MN_PB_PRO_PROTOCOL: "Relatório - TS Monitor PROFIBUS PRO - Protocolo",
  REPORT_MN_PB_PRO_PHYS_MEDIUM: "Relatório - TS Monitor PROFIBUS PRO - Meio Físico DP",
  MASTER: "Mestre ",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Entrar",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha no nível de tensão (Ação Requerida).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha no nível de tensão (Ação Urgente).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha por relé.",

  LOGOUT: "Logout",
  MASK: "Máscara",
  TAGS: "Tags",
  INTERFACE_CONFIG: "Configurações de Interface",
  ARE_YOU_SURE_ALTER_CONFIG: "Tem certeza que deseja alterar as configurações Ethernet do TS Monitor PROFIBUS PRO?",

  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "O arquivo foi enviado com sucesso.",
  SEND_FILE_SUCCESS_WARNING: "Não esqueça de verificar se a placa de rede do seu computador está na mesma subrede do IP: ",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  START_MESSAGE_SUCCESS: "O monitor irá iniciar em 15 segundos.",
  START_MESSAGE_FAILURE: "Ocorreu um erro ao iniciar o monitor.",
  STOP_MESSAGE_SUCCESS: "O monitor irá parar em 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocorreu um erro ao parar o monitor.",
  RESET_TRAFFIC_SUCCESS: "Os valores serão zerados na próxima varredura.",
  RESET_TRAFFIC_FAILURE: "Ocorreu um erro ao zerar os incrementos de erro.",
  RESET_DEVICES_SUCCESS: "Os dados de devices foram limpados com sucesso.",
  RESET_DEVICES_FAILURE: "Ocorreu um erro ao limpar os dados de devices.",
  RESET_RETRIES_SUCCESS: "As retentativas foram limpadas com sucesso.",
  RESET_RETRIES_FAILURE: "Ocorreu um erro ao limpar as retentativas.",

  TAG_TOO_LONG: "\n- O tamanho da tag não pode ultrapassar 30 caracteres",

  SYSTEM: "Sistema",
  RESTART: "Reiniciar",

  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• O IP do TS Monitor PROFIBUS PRO foi modificado com sucesso.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• A observação foi modificada com sucesso.",

  NOTE: "Observação",
  MONITOR_IP: "IP do Monitor",

  IN_SEGMENT_DEVICES: "Dispositivos do segmento",
  UPDATING_DATA: "Atualizando informações, aguarde",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por endereço",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos pertencentes ao mesmo segmento que o TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Se o dispositivo estiver desmarcado nesta lista, isto significa que ele não pertence ao mesmo segmento que o TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Se ele não pertencer ao mesmo segmento, a forma de onda vista no osciloscópio pode não corresponder à forma de onda real do dispositivo.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "Tem certeza que deseja realizar as alterações à lista de dispositivos pertencentes ao segmento?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Ocorreu um erro ao alterar a lista de dispositivos do segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "A lista de dispositivos do segmento foi alterada com sucesso!",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",

  NTP_INFO_TURNED_ON_SUCCESS: "O servidor NTP foi ligado com sucesso.",
  TURN_ON_DATE: "\nO horário do servidor foi atualizado para: ",

  MONITOR_WILL_BE_RESTARTED: "\nO TS Monitor PROFIBUS PRO será reiniciado agora,",

  NTP_INFO_TURNED_OFF_SUCCESS: "O servidor NTP foi desligado com sucesso.",
  TURN_OFF_DATE: "\nHorário de desligamento: ",

  TAG_CONFIG_DP: "Tag do segmento",

  INVALID_MONITOR_IP: "O IP do monitor inserido é inválido.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "O IP do monitor foi modificado com sucesso.",
  MONITOR_IP_CHANGE_FAILURE: "Ocorreu um erro ao modificar o IP do monitor.",

  INVALID_HOSTNAME: "O hostname não estar em branco, nem conter espaços, ou caracteres especiais.",

  CHANGE_IDLE_SIZE: "Alterar tamanho do idle",
  CHANGE_IDLE_SIZE_QUESTION_1: "Alterar o tamanho do idle reiniciará os procedimentos internos do TS Monitor PROFIBUS PRO. Esse procedimento pode levar até 3 minutos.",
  CHANGE_IDLE_SIZE_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  CHANGE_PACKET_SIZE: "Alterar tamanho de pacote",
  CHANGE_PACKET_SIZE_QUESTION_1: "Alterar o tamanho de pacote reiniciará os procedimentos internos do TS Monitor PROFIBUS PRO. Esse procedimento pode levar até 3 minutos.",
  CHANGE_PACKET_SIZE_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  TERMINATION_OFF_LIST_HEADER: "Terminador na posição OFF",
  TERMINATION_OFF_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará possível falta de terminador na rede.",

  NO_TERMINATION_LIST_HEADER: "Segmento sem terminação",
  NO_TERMINATION_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará possível ausência de terminador no segmento ao qual está conectado.",

  NO_POWER_SUPPLY_LIST_HEADER: "Terminador sem alimentação",
  NO_POWER_SUPPLY_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível falta de alimentação no terminador.",

  HIGH_RESISTANCE_LIST_HEADER: "Sinal atenuado",
  HIGH_RESISTANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível excesso de terminadores ou alta resistência no barramento PROFIBUS.",

  A_NOT_OK_LIST_HEADER: "Curto entre o condutor A e a malha",
  A_NOT_OK_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível curto-circuito entre o condutor A e a malha de blindagem ou a massa aterrada de um painel ou escravo.",

  B_NOT_OK_LIST_HEADER: "Curto entre o condutor B e a malha",
  B_NOT_OK_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível curto-circuito entre o condutor B e a malha de blindagem ou a massa aterrada de um painel ou escravo.",

  LONG_CABLE_LIST_HEADER: "Cabo longo",
  LONG_CABLE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de barramento com comprimento maior do que o permitido.",

  NOISE_LIST_HEADER: "Ruído ou baixa isolação (fuga para terra)",
  NOISE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de ruído na rede PROFIBUS.",

  REFLECTION_LIST_HEADER: "Reflexão na forma de onda",
  REFLECTION_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará presença de reflexão na forma de onda.",

  DEFORMED_WAVE_LIST_HEADER: "Sinal deformado",
  DEFORMED_WAVE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará presença de sinal fora do padrão.",

  DUPLICATE_ADDRESS_LIST_HEADER: "Endereço duplicado",
  DUPLICATE_ADDRESS_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará possível presença de dois escravos com o mesmo endereço na rede.",

  // ---------------------------- TS EXPERT ----------------------------

  QUANTITY_DP: "Quantidade: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "A porta ainda está inativa",
  MARK_PROBLEM_AS_SOLVED: "Tem certeza que deseja marcar o evento como conferido?",

  ALL_EVENTS_CHECKED: "Todos os eventos foram conferidos com sucesso.",

  DEVICES: "Dispositivos",

  // ---------------------------- TERMINADOR OFF ----------------------------
  TERMINATION_OFF_SUGGESTION_1: "Quando o terminador estiver na posição OFF sugere-se:",
  TERMINATION_OFF_SUGGESTION_2: "Verificar visualmente:",
  TERMINATION_OFF_SUGGESTION_3: "Se os terminadores em ambas as extremidades do segmento estão na posição \"on\";",
  TERMINATION_OFF_SUGGESTION_4: "Se não forem utilizados conectores PROFIBUS, verificar se existe terminador ativo em ambas as extremidades;",
  TERMINATION_OFF_SUGGESTION_5: "Caso não exista terminador em uma das extremidades é necessário realizar a instalação.",
  TERMINATION_OFF_SUGGESTION_6: "Indica-se aguardar uma parada ou programar com a produção antes de ligar o terminador desligado ou instalar um terminador ativo, uma vez que esta alteração pode derrubar a rede.",

  // ---------------------------- SEM TERMINADOR ----------------------------
  NO_TERMINATION_SUGGESTION_1: "Quando o segmento estiver sem terminação sugere-se:",
  NO_TERMINATION_SUGGESTION_2: "Verificar visualmente se:",

  NO_TERMINATION_SUGGESTION_3: "Se os terminadores em ambas as extremidades do segmento estão na posição \"on\";",
  NO_TERMINATION_SUGGESTION_4: "Se não forem utilizados conectores PROFIBUS, verificar se existe terminador ativo em ambas as extremidades;",
  NO_TERMINATION_SUGGESTION_5: "Caso não exista terminador em uma das extremidades é necessário realizar a instalação.",

  NO_TERMINATION_SUGGESTION_6: "Indica-se aguardar uma parada ou programar com a produção antes de ligar o terminador desligado ou instalar um terminador ativo, uma vez que esta alteração pode derrubar a rede.",

  // ---------------------------- NO POWER SUPPLY ----------------------------
  NO_POWER_SUPPLY_SUGGESTION_1: "Quando o terminador estiver sem alimentação sugere-se:",
  NO_POWER_SUPPLY_SUGGESTION_2: "Verificar a alimentação dos terminadores ativos (quando temos instalado o dispositivo) e verificar a alimentação para terminadores no escravo ou mestre nos pinos do conector DB9, sendo:",
  NO_POWER_SUPPLY_SUGGESTION_3: "No caso de terminador ativo, basta alimentá-lo, mas no caso de conector DB9 é necessário verificar se o problema está no conector ou na alimentação proveniente do escravo ou mestre.",
  NO_POWER_SUPPLY_SUGGESTION_4: "Indica-se realizar estes procedimentos com a produção parada, uma vez que esta alteração pode derrubar a rede.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  HIGH_RESISTANCE_SUGGESTION_1: "Quando o sinal estiver atenuado sugere-se:",
  HIGH_RESISTANCE_SUGGESTION_2: "Verificar:",

  HIGH_RESISTANCE_SUGGESTION_3: "Se algum equipamento do segmento está com terminador interno ligado;",
  HIGH_RESISTANCE_SUGGESTION_4: "Caso não tenha equipamento algum com terminador interno ligado verificar a eletrônica dos escravos, isolando individualmente do barramento;",
  HIGH_RESISTANCE_SUGGESTION_5: "Verificar se existem bornes frouxos nas conexões por borne ou conectores a borne;",
  HIGH_RESISTANCE_SUGGESTION_6: "Verificar mau contato em conectores do tipo “vampiro”;",
  HIGH_RESISTANCE_SUGGESTION_7: "Verificar se existem cabos amassados, o que aumentaria a resistência do cabo.",

  HIGH_RESISTANCE_SUGGESTION_8: "Esta verificação pode ser feita com a rede trabalhando, porém para qualquer intervenção indica-se esperar uma parada, pois estas alteração podem derrubar a rede.",

  // ---------------------------- A NOT OK ----------------------------
  A_NOT_OK_SUGGESTION_1: "Quando houver curto entra o condutor A e a malha sugere-se:",
  A_NOT_OK_SUGGESTION_2: "Realizar inspeção visual:",
  A_NOT_OK_SUGGESTION_3: "Interna dos conectores verificando se há curto entre o condutor A e a malha;",
  A_NOT_OK_SUGGESTION_4: "Por todo o segmento verificando se há algum trecho do cabo danificado prensado em eletrocalha ou cortado em saída de tubulação ou amassado por gaveta de CCM etc.",

  // ---------------------------- B NOT OK ----------------------------
  B_NOT_OK_SUGGESTION_1: "Quando houver curto entre o condutor B e a malha sugere-se:",
  B_NOT_OK_SUGGESTION_2: "Realizar inspeção visual:",
  B_NOT_OK_SUGGESTION_3: "Interna dos conectores verificando se há curto entre o condutor B e a malha;",
  B_NOT_OK_SUGGESTION_4: "Por todo o segmento verificando se há algum trecho do cabo danificado prensado em eletrocalha ou cortado em saída de tubulação ou amassado por gaveta de CCM etc.",

  // ---------------------------- LONG CABLE ----------------------------
  LONG_CABLE_SUGGESTION_1: "Quando o cabo for muito longo sugere-se:",
  LONG_CABLE_SUGGESTION_2: "Fazer uma inspeção visual do segmento e verificar se o barramento está longo demais para o baud rate (taxa de comunicação), segundo a tabela abaixo.",
  LONG_CABLE_SUGGESTION_3: "Caso o segmento esteja maior que o permitido sugere-se inserir um repetidor ou link de fibra óptica, dividindo o segmento.",

  BAUD_RATE_: "Baud rate",
  LENGTH: "Comprimento",
  NINE_SIX_KBITS: "9,6 kbit/s",
  NINETEEN_KBITS: "19,2 kbit/s",
  FORTY_FIVE_KBITS: "45,45 kbit/s",
  NINETY_THREE_KBITS: "93,75 kbit/s",
  HUN_EIGHTY_SEVEN_KBITS: "187,5 kbit/s",
  FIVE_HUNDRED_KBITS: "500,0 kbit/s",
  ONE_FIVE_KBITS: "1,5 Mbit/s",
  THREE_MBPS: "3,0 Mbit/s",
  SIX_MBPS: "6,0 Mbit/s",
  TWELVE_MBPS: "12,0 Mbit/s",

  // ---------------------------- NOISE ----------------------------
  NOISE_SUGGESTION_1: "Quando houver ruído ou baixa isolação (fuga para terra) sugere-se:",
  NOISE_SUGGESTION_2: "3 dicas tendem a ajudar a solucionar este problema:",
  NOISE_SUGGESTION_3: "Para atenuar o ruído é necessário verificar se todos os escravos da rede estão devidamente aterrados;",
  NOISE_SUGGESTION_4: "Corrente medida na blindagem com a blindagem aterrada nas duas extremidades:",
  NOISE_SUGGESTION_5: "Verificar o isolamento das interfaces dos escravos, um modo simples é ir desconectando um a um os escravos do segmento e verificar no TS Monitor se o problema persiste, ou seja, se na Live List os sinais se estabilizam em BOM).",
  NOISE_SUGGESTION_6: "Caso o problema persista após estas dicas indicamos procurar um especialista em redes PROFIBUS.",

  NOISE_SUGGESTION_TABLE_HEADER_1: "Corrente",
  NOISE_SUGGESTION_TABLE_HEADER_2: "Ação",

  NOISE_SUGGESTION_TABLE_11: "5 mA",
  NOISE_SUGGESTION_TABLE_12: "Valor muito bom, a ser buscado especialmente em plantas.",
  NOISE_SUGGESTION_TABLE_21: "30 mA",
  NOISE_SUGGESTION_TABLE_22: "Nenhuma ação é necessária fora de áreas.",
  NOISE_SUGGESTION_TABLE_31: "30 mA a 100 mA",
  NOISE_SUGGESTION_TABLE_321: "Verificar a causa e reduzir o valor para abaixo de ",
  NOISE_SUGGESTION_TABLE_322: "30 mA",
  NOISE_SUGGESTION_TABLE_323: ", se possível.",
  NOISE_SUGGESTION_TABLE_41: "100 mA",
  NOISE_SUGGESTION_TABLE_42: "Eliminar a fonte de interferência, melhorar/interligar a malha de equipotencialização, reduzir correntes parasitas e, se necessário, aumentar a distância entre linhas de potência e linhas de barramento.",
  NECESSARY_ACTION: "Ação necessária: ",

  // ---------------------------- REFLECTION ----------------------------
  REFLECTION_SUGGESTION_1: "Quando houver reflexão na forma de onda sugere-se:",
  REFLECTION_SUGGESTION_2: "Este evento está quase sempre associado a falta de terminação na rede, portanto deve-se verificar visualmente:",

  REFLECTION_SUGGESTION_3: "Se os terminadores em ambas as extremidades do segmento estão na posição “on”;",
  REFLECTION_SUGGESTION_4: "Se não forem utilizados conectores PROFIBUS, verificar se existe terminador ativo em ambas as extremidades;",
  REFLECTION_SUGGESTION_5: "Caso não exista terminador em uma das extremidades é necessário realizar a instalação.",

  REFLECTION_SUGGESTION_6: "No entanto, a reflexão também pode ser resultado de emenda no cabo, uso de bornes inadequados, cabos amassados, mudança de tipo de cabo, uso de emenda com M12 ou qualquer outra alteração no meio físico de comunicação.",
  REFLECTION_SUGGESTION_7: "Nestes casos, faz-se necessária uma inspeção visual detalhada no segmento de rede indicado.",

  // ---------------------------- DEFORMED WAVE ----------------------------
  DEFORMED_WAVE_SUGGESTION_1: "Quando um sinal deformado for detectado sugere-se:",
  DEFORMED_WAVE_SUGGESTION_2: "Verificar o barramento em busca de:",
  DEFORMED_WAVE_SUGGESTION_3: "Escravo com endereço repetido;",
  DEFORMED_WAVE_SUGGESTION_4: "Cabos dobrados;",
  DEFORMED_WAVE_SUGGESTION_5: "Bornes frouxos;",
  DEFORMED_WAVE_SUGGESTION_6: "Conectores mau montados;",
  DEFORMED_WAVE_SUGGESTION_7: "Cabos amassados;",
  DEFORMED_WAVE_SUGGESTION_8: "Cabos cortados ou danificados;",
  DEFORMED_WAVE_SUGGESTION_9: "Alimentação errada de terminadores ativos.",

  // ---------------------------- DUPLICATE ADDRESS ----------------------------
  DUPLICATE_IP_SUGGESTION_1: "Quando um endereço estiver duplicado sugere-se:",
  DUPLICATE_IP_SUGGESTION_2: "Realizar uma inspeção visual na rede e verificar se existem dois ou mais escravos com o mesmo endereço. Caso exista, verificar qual é o escravo correto e endereçar o outro com um nó livre.",

  // ---------------------------- EXPERT REPORT ----------------------------
  SAVE_ACTIONS_LIST: "Salvar lista de ações",
  ACTIONS_LIST_FILENAME_PART: "Lista de ações - TS Monitor PROFIBUS PRO",

  TERMINATION_OFF_PAGE_TITLE: ". - Terminador na posição OFF",
  NO_TERMINATION_PAGE_TITLE: ". - Segmento sem terminação",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminador sem alimentação",
  HIGH_RESISTANCE_PAGE_TITLE: ". - Sinal atenuado",
  A_NOT_OK_PAGE_TITLE: ". - Curto entra o condutor A e a malha",
  B_NOT_OK_PAGE_TITLE: ". - Curto entre o condutor B e a malha",
  LONG_CABLE_PAGE_TITLE: ". - Cabo longo",
  NOISE_PAGE_TITLE: ". - Ruído ou baixa isolação (fuga para terra)",
  REFLECTION_PAGE_TITLE: ". - Reflexão na forma de onda",
  DEFORMED_WAVE_PAGE_TITLE: ". - Sinal deformado",
  DUPLICATE_PAGE_TITLE: ". - Endereço duplicado",

  TERMINATION_OFF_DOTS: ".......................................................................................................",
  NO_TERMINATION_DOTS: "........................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  HIGH_RESISTANCE_DOTS: "............................................................................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: ".................................................................................",
  REFLECTION_DOTS: "........................................................................................................",
  DEFORMED_WAVE_DOTS: ".......................................................................................................................",
  DEFORMED_WAVE_DOTS_2: ".........................................................................................................................",

  DUPLICATE_ADDRESS_DOTS: "..................................................................................................................",
  DUPLICATE_ADDRESS_DOTS_2: "....................................................................................................................",

  SUGGESTION: "Sugere-se",
  EVIDENCE: "Evidências",
  EVIDENCE_DESCRIPTION: "Captura de evidência da não conformidade informada pelo TS Expert:",

  TERMINATION_OFF_PAGE_DESCRIPTION: "O TS Expert está indicando uma possível falta de terminador na rede.",
  NO_TERMINATION_PAGE_DESCRIPTION: "O TS Expert está indicando uma possível ausência de terminador no segmento ao qual está conectado.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "O TS Expert está indiciando uma possível falta de alimentação no terminador.",
  HIGH_RESISTANCE_PAGE_DESCRIPTION: "O TS Expert está indicando possível excesso de terminadores ou alta resistência no barramento PROFIBUS.",
  A_NOT_OK_PAGE_DESCRIPTION: "O TS Expert está indicando possível curto-circuito entre o condutor A e a malha de blindagem ou a massa aterrada de um painel ou escravo.",
  B_NOT_OK_PAGE_DESCRIPTION: "O TS Expert está indicando possível curto-circuito entre o condutor B e a malha de blindagem ou a massa aterrada de um painel ou escravo.",
  LONG_CABLE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de barramento com comprimento maior do que o permitido.",
  NOISE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de ruído na rede PROFIBUS.",
  REFLECTION_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de reflexão na forma de onda.",
  DEFORMED_WAVE_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de sinal fora do padrão",
  DUPLICATE_PAGE_DESCRIPTION: "O TS Expert está indicando a possível presença de endereço duplicado.",

  TERMINATION_OFF_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado terminador na posição OFF:\n",
  NO_POWER_SUPPLY_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado terminador sem alimentação:\n",
  HIGH_RESISTANCE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado sinal atenuado:\n",
  A_NOT_OK_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado curto entra o condutor A e a malha:\n",
  B_NOT_OK_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado curto entra o condutor B e a malha:\n",
  LONG_CABLE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado cabo com comprimento longo:\n",
  NOISE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado ruído ou baixa isolação:\n",
  REFLECTION_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois ainda está sendo detectado reflexão na forma de onda:\n",

  S_TERMINATION_OFF_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado que terminador está na posição OFF\n",
  S_NO_POWER_SUPPLY_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado que o terminador está sem alimentação\n",
  S_HIGH_RESISTANCE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado que existem 2 terminadores, ou que a resistência no barramento está alta\n",
  S_A_NOT_OK_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado possível curto-circuito entre o condutor A e a malha de blindagem, ou a massa aterrada de um painel ou escravo\n",
  S_B_NOT_OK_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado possível curto-circuito entre o condutor B e a malha de blindagem, ou a massa aterrada de um painel ou escravo\n",
  S_LONG_CABLE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado possível condição de barramento com comprimento maior do que o permitido\n",
  S_NOISE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado possível condição de ruído na rede PROFIBUS\n",
  S_REFLECTION_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ainda está sendo detectado a presença de reflexão na forma de onda\n",

  // ---------------------------- Temperature Alert ----------------------------
  IDLE_SIZE: "Tamanho do idle",
  PACKET_SIZE: "Tamanho de pacote",

  SMALL: "Pequeno",
  MEDIUM: "Médio",
  BIG: "Grande",

  IDLE_SIZE_QUESTION_ICON_INFO: "O tamanho do idle diz respeito à quantidade de pontos considerados no começo da forma de onda da resposta do device. É possível configurar três tamanhos distintos:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Tamanho do idle padrão (Varia de acordo com o baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Aumenta o tamanho em 1 tempo de um bit;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Aumenta o tamanho em 2 tempos de um bit.",

  PACKET_SIZE_QUESTION_ICON_INFO: "O tamanho de pacote é a quantidade total de pontos que são capturados pelo TS Monitor PROFIBUS PRO em um único pacote de dados. É possível configurar três tamanhos distintos:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Tamanho de pacote padrão (Varia de acordo com o baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Aumenta o tamanho de pacote em 100 pontos;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Aumenta o tamanho de pacote em 200 pontos.",

  IDLE_SIZE_WAITING: "Realizando procedimentos para alterar o tamanho do idle, por favor aguarde nesta tela até que eles terminem.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "O tamanho do idle foi alterado com sucesso",
  IDLE_SIZE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o tamanho do idle.",

  PACKET_SIZE_WAITING: "Realizando procedimentos para alterar o tamanho do pacote, por favor aguarde nesta tela até que eles terminem.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "O tamanho de pacote foi alterado com sucesso",
  PACKET_SIZE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o tamanho do pacote.",

  REASON_DP: "Motivo: ",

  // ---------------------------- Segment Devices ----------------------------
  CHECK_MASTER: "Verificar mestre",
  START_SEARCH_ERROR_MESSAGE: "Ocorreu um erro ao iniciar a busca de dispositivos. Por favor tente novamente.",
  SEARCH_FINISH_SUCCESS: "Busca por dispositivos finalizada com sucesso!",
  GET_DEVICES_LIST_ERROR: "Ocorreu um erro ao carregar a lista de dispositivos.",

  IN_SEGMENT: "Atualmente no segmento",
  POSSIBLY_IN_SEGMENT: "Identificado como pertencente",
  POSSIBLY_OUT_OF_SEGMENT: "Foi detectado que este dispositivo pode estar em outro segmento",

  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "As informações sobre os dispositivos do segmento foram enviadas com sucesso!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "Ocorreu um erro ao enviar as informações sobre os dispositivos do segmento.",

  SEARCH: "Buscar",
  SEARCH_POPUP_1: "Para utilizar a parte de Meio Físico DP pela primeira vez é recomendado selecionar quais dispositivos pertencem ao segmento.",
  SEARCH_POPUP_2: "Aperte o botão abaixo para fazer uma busca e encontrar todos dispositivos alcançaveis na rede.",
  SEARCH_POPUP_3_1: "Após a busca, os dispositivos encontrados serão adicionados à lista de ",
  SEARCH_POPUP_3_2: "dispositivos disponíveis",
  SEARCH_POPUP_3_3: " ao lado. Os dispositivos disponíveis ",
  SEARCH_POPUP_3_4: "são todos aqueles encontrados, que pertencem ao segmento de rede atual, ou não.",
  SEARCH_POPUP_4_1: "A outra lista, de ",
  SEARCH_POPUP_4_2: "dispositivos selecionados",
  SEARCH_POPUP_4_3: ", é a lista que ",
  SEARCH_POPUP_4_4: "contém os dispositivos selecionados pelo usuário que ele tem certeza que estão no segmento de rede atual.",
  SEARCH_POPUP_4_5: " Inicialmente esta lista estará vazia.",
  SEARCH_POPUP_5: "Feito a busca, caberá ao usuário selecionar quais destes dispositivos realmente percentem ao segmento de rede, movendo eles da lista de dispositivos disponíveis para a lista de dispositivos selecionados.",
  SEARCH_POPUP_6_1: "OBS: ",
  SEARCH_POPUP_6_2: "Os mestres da rede são sempre monitorados pelo TS Monitor PROFIBUS PRO, portanto não aparecem nesta página.",

  SAVE_POPUP_1_1: "Ao clicar no botão abaixo, os dispositivos que estiverem na lista ",
  SAVE_POPUP_1_2: "Dispositivos selecionados",
  SAVE_POPUP_1_3: " serão salvos.",
  SAVE_POPUP_2_1: "Ao realizar este procedimento, apenas os dispositivos da lista ",
  SAVE_POPUP_2_2: "Dispositivos selecionados",
  SAVE_POPUP_2_3: " serão monitorados pelo Meio Físico DP, e ",
  SAVE_POPUP_2_4: "somente eles serão mostrados nas telas de Meio Físico DP, como: Live List, Matriz, Osciloscópio, etc.",

  EXPLANATION: "Explicação",

  SAVE_POPUP_3: "Esta funcionalidade é importante para identificar os escravos pertencentes ao segmento de rede PROFIBUS. O que diminui o tempo de reposta uma vez que o sistema estará verificando os escravos pertinentes.",
  SAVE_POPUP_4: "Também é de grande valia para que aqueles que tenham menor conhecimento da rede não procurem o problema em um segmento errado.",

  AVAILABLE_DEVICES: "Dispositivos disponíveis",
  AVAILABLE_DEVICES_POPUP_1_1: "Esta lista contém todos os dispositivos ",
  AVAILABLE_DEVICES_POPUP_1_2: "encontrados na rede.",
  AVAILABLE_DEVICES_POPUP_2: "O TS Monitor PROFIBUS PRO sugere os dispositivos que ele acredita pertencerem ao segmento de rede atual, indicando eles como: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identificado como pertencente.",

  AVAILABLE_DEVICES_POPUP_3_1: "Clicar no botão ",
  AVAILABLE_DEVICES_POPUP_3_2: " move um dispositivo da lista de ",
  AVAILABLE_DEVICES_POPUP_3_3: "dispositivos disponíveis",
  AVAILABLE_DEVICES_POPUP_3_4: " para a lista de ",
  AVAILABLE_DEVICES_POPUP_3_5: "dispositivos selecionados",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicando que ele pertence ao segmento atual da rede. Após mover os dispositivos é necessário clicar no botão ",
  AVAILABLE_DEVICES_POPUP_3_7: "Salvar",
  AVAILABLE_DEVICES_POPUP_3_8: " para gravar essas alterações.",

  AVAILABLE_DEVICES_POPUP_4_1: "OBS: ",
  AVAILABLE_DEVICES_POPUP_4_2: "Fica a cargo do usuário tomar a decisão final e decidir quais dispositivos realmente pertencem ao segmento.",

  LOADING_DEVICES: "Carregando dispositivos",

  MOVE_ALL: "Mover todos",

  SELECTED_DEVICES: "Dispositivos selecionados",

  SELECTED_DEVICES_POPUP_1_1: "Esta lista contém todos os dispositivos que o usuário marcou como ",
  SELECTED_DEVICES_POPUP_1_2: "pertencentes ao segmento de rede atual.",

  SELECTED_DEVICES_POPUP_2_1: "É importante ressaltar que após clicar no botão ",
  SELECTED_DEVICES_POPUP_2_2: "Salvar",
  SELECTED_DEVICES_POPUP_2_3: ", a parte de Meio Físico DP ",
  SELECTED_DEVICES_POPUP_2_4: "somente irá monitorar os dispositivos que estiverem na lista de dispositivos selecionados.",

  SELECTED_DEVICES_POPUP_3_1: "Isto significa que:",
  SELECTED_DEVICES_POPUP_3_2: " Os dispositivos que não estiverem nesta lista não serão mostrados nas telas de Meio Físico DP, tais como: Live list, Matriz, Osciloscópio, Gráfico de barras, etc.",

  CONFIRM_SEARCH_START: "Tem certeza que deseja iniciar a busca?",

  CONFIRM_SEARCH_START_POPUP_1_1: "O procedimento de busca de dispositivos levará ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (cinco) minutos",
  CONFIRM_SEARCH_START_POPUP_1_3: " para ser completado.",

  CONFIRM_SEARCH_START_POPUP_2_1: " Durante a busca ",
  CONFIRM_SEARCH_START_POPUP_2_2: "diversos procedimentos internos do TS Monitor PROFIBUS PRO serão reiniciados",
  CONFIRM_SEARCH_START_POPUP_2_3: ", e por esta razão, ele somente voltará a funcionar normalmente após a busca ser finalizada.",

  SEARCHING_DEVICES: "Buscando dispositivos.",
  PLEASE_STAY_IN_PAGE: "Por favor permaneça na página para acompanhar o progresso da busca.",

  SENDING_DEVICES_INFO: "Enviando informações sobre os dispositivos, aguarde.",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Português",
  ENGLISH: "Inglês",
  SPANISH: "Espanhol",
  GERMAN: "Alemão",
  UPDATING_LANGUAGE_WAITING: "Alterando idioma, aguarde um instante",
  UNABLE_TO_ALTER_LANGUAGE: "Não foi possivel alterar o idioma do programa.\n",

  // ---------------------------- SHARED STRINGS ----------------------------
  MONITORING: "Protocolo",
  PHYS_MEDIUM: "Meio físico DP",
  GENERAL: "Gerais",
  TS_EXPERT_PROT: "TS Expert - Protocolo",
  TS_EXPERT_DP: "TS Expert - Meio Físico DP",
  TS_EXPERT_OF: "TS Expert - Fibra Ótica",
  HEADER_TEXT_PRO: "Relatório de dados - TS Monitor PROFIBUS PRO",
  PHYS_MEDIUM_DOTS: "..........................................................................................................",
  MONITORING_DOTS: ".................................................................................................................",
  DISCLAIMER_DOTS_PRO: ".......................................................................................................................................",

  NETWORK_DP: "Rede:",
  SEGMENT_DP: "Segmento:",

  IP_ASSOCIATED_MONITOR: "IP do monitor associado: ",
});

export default Constants;